import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Input, type InputProps } from './input.js';

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type' | 'suffix'>>(
  (props, ref) => {
    const [visible, setVisible] = useState(false);
    const { t } = useTranslation('auth');

    return (
      <Input
        {...props}
        ref={ref}
        type={visible ? 'text' : 'password'}
        suffix={
          <button
            type="button"
            onClick={() => setVisible((v) => !v)}
            aria-label={t(visible ? 'hidePassword' : 'showPassword')}
            className="text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors"
          >
            {visible ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
          </button>
        }
      />
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
